export const topRankLayout = (totalRank: number, isMobile?: boolean) => {
  if (totalRank <= 0) return [];
  if (isMobile) {
    return totalRank === 1 ? [1] : totalRank === 2 ? [1, 2] : [1, 2, 3];
  }
  return totalRank === 1 ? [1] : totalRank === 2 ? [1, 2] : [2, 1, 3];
};
